import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { INotification } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'

export const fetchMoreNotifications = createAsyncThunk<
    { hasMore: boolean; notifications: INotification[] } | void,
    { lastNotificationId: string | undefined; productIds: string[] },
    ThunkConfig<string>
>('notificationsSlice/fetchMoreNotifications', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { lastNotificationId, productIds } = args

    try {
        const { data } = await api.get<{
            notifications: INotification[]
            has_more: boolean
        }>(getUrlWithVersion(`/notifications`), {
            params: {
                before: lastNotificationId,
                product_ids: productIds,
            },
            paramsSerializer: {
                indexes: null,
            },
        })

        if (
            typeof data?.has_more !== 'boolean' ||
            !Array.isArray(data?.notifications)
        ) {
            const error = new Error('Received notifications in wrong format')
            console.error(error.message)
            return
        }

        return { hasMore: data.has_more, notifications: data.notifications }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to load more notifications')
    }
})
